import React, { Component } from 'react'
import { connect } from 'react-redux'

import { TicketOverview as TicketOverview23 } from 'projects/flow-gui-access/views/2.3/ticket'
import { TicketOverview as TicketOverview24 } from 'projects/flow-gui-access/views/2.4/ticket'

class TicketOverview extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.4').length !== 0) {
      return <TicketOverview24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.3').length !== 0) {
      return <TicketOverview23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
TicketOverview = connect(state => state)(TicketOverview)
export default TicketOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/ticket/overview.js